import { render } from "./MessageCondensed.vue?vue&type=template&id=dd9173ba&ts=true"
import script from "./MessageCondensed.vue?vue&type=script&lang=ts"
export * from "./MessageCondensed.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageCondensed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd9173ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd9173ba', __exports__)) {
    api.reload('dd9173ba', __exports__)
  }
  
  module.hot.accept("./MessageCondensed.vue?vue&type=template&id=dd9173ba&ts=true", () => {
    api.rerender('dd9173ba', render)
  })

}


export default __exports__